import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OfflineCacheService {
  private readonly CACHE_KEY = 'offline_despachos_actions';
  private readonly CONNECTION_KEY = 'last_connection_status';

  constructor() {}

  // Guardar acción en cache
  saveAction(action: any): void {
    const actions = this.getPendingActions();
    actions.push({
      ...action,
      timestamp: new Date().toISOString(),
      id: this.generateId()
    });
    localStorage.setItem(this.CACHE_KEY, JSON.stringify(actions));
  }

  // Obtener acciones pendientes
  getPendingActions(): any[] {
    const actions = localStorage.getItem(this.CACHE_KEY);
    return actions ? JSON.parse(actions) : [];
  }

  // Eliminar acción del cache
  removeAction(actionId: string): void {
    const actions = this.getPendingActions();
    const filteredActions = actions.filter(action => action.id !== actionId);
    localStorage.setItem(this.CACHE_KEY, JSON.stringify(filteredActions));
  }

  // Limpiar todas las acciones
  clearAllActions(): void {
    localStorage.removeItem(this.CACHE_KEY);
  }

  // Verificar si hay acciones pendientes
  hasPendingActions(): boolean {
    return this.getPendingActions().length > 0;
  }

  // Verificar estado de conexión
  isOnline(): boolean {
    return navigator.onLine;
  }

  // Guardar estado de conexión
  setConnectionStatus(online: boolean): void {
    localStorage.setItem(this.CONNECTION_KEY, online.toString());
  }

  // Obtener último estado de conexión
  getLastConnectionStatus(): boolean {
    const status = localStorage.getItem(this.CONNECTION_KEY);
    return status ? status === 'true' : true;
  }

  private generateId(): string {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }
}